import { Autocomplete, Chip, TextField } from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';

interface DropdownWithLabelsFieldProps {
  name: string;
  defaultValues: String[];
  options: String[];
  label?: string;
}

export function DropdownWithLabelsField({ name, defaultValues, options, label }: DropdownWithLabelsFieldProps) {
  const { setValue } = useFormContext();
  const {
    field: { value },
  } = useController({
    name,
    defaultValue: defaultValues,
  });

  return (
    <Autocomplete
      multiple
      id={name}
      value={value}
      onChange={(event, newValue) => {
        setValue(name, [...defaultValues, ...newValue.filter(option => defaultValues.indexOf(option) === -1)]);
      }}
      options={options}
      getOptionLabel={option => option}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip label={option} {...getTagProps({ index })} disabled={defaultValues.indexOf(option) !== -1} />
        ))
      }
      style={{ width: 500 }}
      renderInput={params => <TextField {...params} label={label} />}
    />
  );
}
